import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProgramDetailsService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.API_URL;

    getProgramDetails(programId: string, studentId: string): Observable<any> {
        return this.http.get(`${this.baseUrl}/students/program-details`, { params: { programId, studentId } });
    }
}
